module.exports = __webpack_public_path__ + "img/select-img-3.3eee58b4.png";